import { Loan } from '../../../types/loan';

export const emptyLoan: Loan = {
  clientId: '',
};
